import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStudioDisplay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStudioDisplay"><Path d="M8.5 17.5H2.5V4.5H21.5V17.5H15.5M8.5 17.5V20.5H15.5V17.5M8.5 17.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconStudioDisplay;
